import ClientsTable from "./ClientsTable"

export default  ClientsTable;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/ClientsTable/index.js